module.exports = __webpack_public_path__ + "static/img/404.be37d8c5.png";